import { SINGLE_SELECT_DEFAULT_VALUE } from '../custom-field-types';

export const isConsumerFieldValueEmpty = (value) => {
  return !value || value === SINGLE_SELECT_DEFAULT_VALUE || value === " " || value === "null";
};



// WEBPACK FOOTER //
// ./src/lib/consumer-fields/validation-helper.js